import { Autocomplete, TextField } from '@mui/material';
import * as React from 'react';
import { UserDto, UsersRycApiClient } from '../Api/ApiServer';
import { useApi } from '../Api/useApi';

export interface IUsersSelectProps {
    selectedUser: UserDto | null;   
    onUserSelect: (user: UserDto | null) => void;
}

export default function UsersSelect(props: IUsersSelectProps) {
    // const [selectedUser, setSelectedUser] = React.useState<UserDto | null>(null);
    const [users, setUsers] = React.useState<UserDto[]>([]);
    const { authorizedApi } = useApi(UsersRycApiClient);
    const loadPartners = React.useCallback(async () => {
        const users: UserDto[] = (await authorizedApi?.usersList())?.users ?? [];
        setUsers(users);
    }, [authorizedApi]);
    React.useEffect(() => {
        loadPartners();
    }, [loadPartners]);
    return (
        <Autocomplete
            fullWidth

            value={props.selectedUser}
            onChange={(e, value) => {
                props.onUserSelect(value);
            }}
            options={users}
            getOptionLabel={(option) => option.name + ' (' + option.email + ')'}
            renderInput={(params) => <TextField {...params} fullWidth label={'Uživatelé'} variant="outlined" />}
        />
    );
}
